import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [ 
  {
    path: '/',
    redirect: '/home',
    component: () => import('@/views/websitePage/home.vue'),
    children: [          
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/websitePage/home.vue')
      }     
    ]
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('@/views/websitePage/detail.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
